/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { UpdateOnboardingContactsApiArg, UpdateOnboardingDraftResponse } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    updateOnboardingContacts: build.mutation<UpdateOnboardingDraftResponse, UpdateOnboardingContactsApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'PATCH',
        url: `/v1/onboarding/contacts`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as updateOnboardingContactsApi };
export const { useUpdateOnboardingContactsMutation } = injectedRtkApi;
